export const MAP_ACTIONS = Object.freeze({
    NEW_OCCURRENCE: "newoccurrence",
    STREET_VIEW: "streetview",
    SCHOOL_DISTANCE: "schooldistance",
    NEW_ACCIDENT: "newaccident",
    NEW_WORK: "newwork",
    PRINT_VISIBLE: "print_visible_emissions",
    MEASURE: "measure",
});